<main>
  <div class="content">
    <section>
      <div class="grid-1">
        <div class="span-1">
          <p-message severity="warn" icon="pi pi-lock" [text]="'Unauthorized_Mesagge' | translateWF: 'You don`t have access for this section!'" styleClass="h-full" />
          @if (!isUserAuthenticated) {
            <div class="m-[1rem] w-full text-center">
              <p-button [label]="'Login' | translateWF: 'Login'" [routerLink]="'/login'"></p-button>
            </div>
          }
        </div>
      </div>
    </section>
  </div>
</main>
